import { RecaptchaModule } from 'ng-recaptcha';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { RecaptchaComponent } from './recaptcha/recaptcha.component';

import { CaptchaService } from './captcha.service';

@NgModule({
  declarations: [AppComponent, ContactFormComponent, RecaptchaComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RecaptchaModule.forRoot()
  ],
  providers: [CaptchaService],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/Users/dtarc/source/repos/CODESENDER/web/src/app/app.module.ts